/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:no-non-null-assertion

import { OfficeDto, WidgetsDto } from '@gh/builder-shared-data';
import { constant } from 'lodash';
import { Observable, Subscription } from 'rxjs';

export type Office = OfficeDto;
export type WidgetsModel = WidgetsDto;

export type WidgetState = {
  loaded: boolean;
  loading: boolean;
  error?: any;
  subscription?: Subscription;
};

export interface WidgetDataLoader {
  init(widget: WidgetsModel): Observable<any>;

  update(widget: WidgetsModel, query: any): Observable<any>;
}

export interface WidgetRenderer {
  init(widget: WidgetsModel, data: any): void;

  update(widget: WidgetsModel, data: any): void;

  destroy(widget: WidgetsModel): void;
}

export function createWidgetDataLoader(ob$: Observable<any>): WidgetDataLoader {
  return {
    init: constant(ob$),
    update: constant(ob$),
  };
}
